import { controls, currencyToNumber, grouped } from "../../controls";

const tgc_list = {
  label: "Track Girl Child List",
  starting: true,
  url: "tgc_list",
  pageLabel: "Track Girl Child List",
  pageType: "history",
  visitingBranches: true,
  filter: [

    ...controls.displayText({
      tab: "filter", label: "Village", star: true,
      width: "col-sm-2"
    }),
    ...controls.autoComplete({ tab: "filter", name: "village_code", controlType: "Village", width: "col-sm-4", }),

    ...controls.displayText({ tab: "filter", label: "From Age" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "", name: "from_age", maxlength: 3 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "To Age" }),
    ...controls.numberOnly({ tab: "filter", placeHolder: "", name: "to_age", maxlength: 3 }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),

    ...controls.displayText({ tab: "general", label: "Name", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "name", width: "col-sm-4", maxlength: 200 }),

    ...controls.displayText({ tab: "general", label: "Fathers Name", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "father_name", width: "col-sm-4", maxlength: 200 }),

    ...controls.displayText({ tab: "general", label: "Mothers Name", star: false }),
    ...controls.text({ tab: "general", placeHolder: "", name: "mother_name", width: "col-sm-4", maxlength: 200 }),


  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Track Girl Child List",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },

    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Full Name",
        accessor: "name",
        rwidth: "*"
      },
      {
        Header: "Mothers Name",
        accessor: "mothers_name"
      },
      {
        Header: "Fathers Name",
        accessor: "fathers_name"
      },
      {
        Header: "Date Of Birth",
        accessor: "date_of_birth",
        type: "date"
      },
      {
        Header: "Is Matched",
        accessor: "is_matched"
      },
      {
        Header: "Remark",
        accessor: "remark"

      },
      {
        Header: "Status",
        accessor: "status"

      },
      {
        Header: "Unique Identification Number",
        accessor: "matched_id"
      },
      {
        Header: "Matched Name",
        accessor: "matched_name"
      },
      {
        Header: "Portal Mothers Name",
        accessor: "portal_mothers_name"
      },
      {
        Header: "Portal Date Of Birth",
        accessor: "up_dob",
        type: "date"
      },
      {
        Header: "Matched Portal",
        accessor: "matched_portal"
      },

    ]
  }
};

export default tgc_list;